import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

export default function ProtectedRoute({ children }) {
  const { user, token, loading } = useSelector((state) => state.user);
  const location = useLocation();

  if (token && loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center vh-100"
        style={{ backgroundColor: "#000", color: "#fff" }}
      >
        <Spinner animation="border" variant="warning" size="lg" />
      </div>
    );
  }

  if (!user && !token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!user && !loading) {
    // Token existed but user fetch failed or finished with no user
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
